/**
 * Viewport Reset Utility
 * Resets the viewport scale to 1.0 - useful after iOS auto-zoom on inputs
 */

export const resetViewport = () => {
  // Force viewport to reset to scale 1.0
  const viewportMeta = document.querySelector('meta[name="viewport"]');

  if (viewportMeta) {
    // Temporarily change viewport to force a reset
    const originalContent = viewportMeta.getAttribute('content');
    viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0');

    // Wait a moment then restore original
    setTimeout(() => {
      viewportMeta.setAttribute('content', originalContent);
    }, 100);
  }

  // Also try to programmatically scroll to top to force a re-layout
  window.scrollTo(0, 0);

  // Force a re-flow
  document.body.style.zoom = '1.0';
};

export const initializeViewport = () => {
  // Set initial viewport scale
  const viewportMeta = document.querySelector('meta[name="viewport"]');
  if (viewportMeta) {
    const content = viewportMeta.getAttribute('content');
    if (!content.includes('initial-scale')) {
      viewportMeta.setAttribute('content', content + ', initial-scale=1.0');
    }
  }
};
